import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Stageplan from './stageplan'

class Stageplans extends Component {
  render() {
    const { view, stageplans, categories } = this.props

    return stageplans && stageplans.length > 0
    ? stageplans.map((stageplan, index) => (
      <Stageplan key={index}
        view={view}
        stageplan={stageplan}
        items={stageplan.items}
        categories={categories}
        editRiderStageplan={this.props.editRiderStageplan}
        addRiderStageplanItem={this.props.addRiderStageplanItem}
        removeRiderStageplanItem={this.props.removeRiderStageplanItem}
        createRiderStageplanItem={(item) => this.props.createRiderStageplanItem(stageplan.id, item)}
        editRiderStageplanItem={this.props.editRiderStageplanItem}
        deleteRiderStageplanItem={this.props.deleteRiderStageplanItem} />
    ))
    : view.editable
      ? <section className="stageplan">
          <div className="section-head">
            <h2>Stageplan</h2>

            <button onClick={() => this.props.createRiderStageplan({
              title: 'minu stageplan',
              description: 'stageplani kirjeldus',
              width: '1000',
              height: '500'
            })}>Create a stageplan</button>
          </div>
        </section>
      : null
  }
}

Stageplans.propTypes = {
  view: PropTypes.object,
  stageplans: PropTypes.array,
  categories: PropTypes.object,
  createRiderStageplan: PropTypes.func,
  editRiderStageplan: PropTypes.func,
  deleteRiderStageplan: PropTypes.func,
  addRiderStageplanItem: PropTypes.func,
  removeRiderStageplanItem: PropTypes.func,
  createRiderStageplanItem: PropTypes.func,
  editRiderStageplanItem: PropTypes.func,
  deleteRiderStageplanItem: PropTypes.func
}

Stageplans.defaultProps = {
  view: {},
  stageplans: [],
  categories: {},
  createRiderStageplan: function() {},
  editRiderStageplan: function() {},
  deleteRiderStageplan: function() {},
  addRiderStageplanItem: function() {},
  removeRiderStageplanItem: function() {},
  createRiderStageplanItem: function() {},
  editRiderStageplanItem: function() {},
  deleteRiderStageplanItem: function() {}
}

export default Stageplans



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplans.js